var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"time-scale"},[_vm._l((_vm.guideState.getTimes()),function(time){return _c('div',{key:time,staticClass:"white--text item",class:_vm.getItemClass(time)},[_vm._v(" "+_vm._s(time)+" ")])}),_c('div',{staticClass:"item dummy"},[_vm._v("dummy")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }